import React from "react";
import {
  Box,
  Button,
  CardMedia,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Stack,
  Tooltip,
} from "@mui/material";
import { styled } from "@mui/system";
import QrCode2TwoToneIcon from "@mui/icons-material/QrCode2TwoTone";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import api from "../api/api";
import LoginDialog from "../component/LoginDialog";
import { useTheme } from "@mui/material/styles";
import verifyToken from "../api/user/verifyToken";
import FadeWrapper from "../component/FadeWrapper";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import TabsView from "../component/TabsView";
import QRCodeDialog from "../component/QRCodeDialog";
import CustomIconButton from "../component/CustomIconButton";
import couponIcon from "../icons/index_coupon.png";
import newsIcon from "../icons/index_news.png";
import orderIcon from "../icons/index_order.png";
import pointIcon from "../icons/index_point.png";
import userIcon from "../icons/index_user.png";
import reserveIcon from "../icons/index_reserve.png";
import qrcodeIcon from "../icons/index_qrcode.png";
import { useSearchParams } from "react-router-dom";
import { PosParamsProvider } from "../context/PosContext";
import ImageTabsView from "../component/ImageTabsView";
import ImageGallery from "../component/ImageGallery";
const StyledCardMedia = styled(CardMedia)(({ theme }) => ({
  borderRadius: "10px",
  height: "30%",
  margin: "5px 2px",
}));
const SecondCardMedia = styled(CardMedia)(({ theme }) => ({
  height: "15vh",
  borderRadius: "10px",
  margin: "5px 1px",
}));

const MainPage = () => {
  const navigate = useNavigate();

  const theme = useTheme();
  const [loginOpen, setLoginOpen] = useState(false);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openQRCode, setOpenQRCode] = useState(false);
  const handleLoginOpen = () => setLoginOpen(true);
  const userContext = useContext(AuthContext);
  let [searchParams, setSearchParams] = useSearchParams();

  const FullWidthButton = styled(Button)(({ theme }) => ({
    width: "calc(50% - 5px)",
    height: "8vh",
    fontSize: "14pt",
    fontWeight: 550,
    background: theme.gradients.primary,
    color: theme.palette.text.selected,
    border: theme.gradients.primary,
    borderRadius: "10px",
  }));
  const SecondFullWidthButton = styled(Button)(({ theme }) => ({
    width: "calc(50% - 5px)",
    height: "8vh",
    fontSize: "14pt",
    fontWeight: 550,
    background: theme.palette.primary.main,
    color: theme.palette.text.blue,
    zIndex: 1,
    borderRadius: "10px",
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: -1,
      borderRadius: "inherit",
      padding: "2.5px",
      background: theme.palette.selected,
      WebkitMask: ` 
linear-gradient(#fff 0 0) content-box, 
linear-gradient(#fff 0 0)`,
      WebkitMaskComposite: "xor",
      maskComposite: "exclude",
    },
  }));
  const handleButtonClick = (path) => {
    navigate(path);
  };

  useEffect(() => {
    const storedToken = localStorage.getItem("token");

    if (storedToken !== "" && storedToken !== null) {
      setToken(storedToken);
    }
  }, []);
  useEffect(() => {
    const lat = searchParams.get('lat');
    const lng = searchParams.get('lng');
    const src=searchParams.get('src');
    if ((lat !== null && lat !== 0) && (lng !== null && lng !== 0)) {

      userContext.setPos({ lat: parseFloat(lat), lng: parseFloat(lng) });
    }
    if(src==="app"){
      
    }
  }, [searchParams]);
  useEffect(() => {
    const fetchUser = async () => {
      try {
        setLoading(true);
        const responseData = await verifyToken();
        if (responseData.code === "000") {
          userContext.setUser(responseData.user);
        } else {
          userContext.setUser(null);
          localStorage.removeItem("token");
          api.defaults.headers.common["Authorization"] = "";
        }
      } catch (err) {
        userContext.setUser(null);
        localStorage.removeItem("token");
        api.defaults.headers.common["Authorization"] = "";
      } finally {
        setLoading(false);
      }
    };

    if (token !== "" && token !== null) {
      fetchUser();
    }
  }, [token]);
  useEffect(() => {
    if (userContext.user) {
      localStorage.setItem("user", JSON.stringify(userContext.user));
    }
  }, [userContext.user]);

  function logout() {
    // Remove the token from localStorage
    localStorage.removeItem("token");
    api.defaults.headers.common["Authorization"] = "";
    userContext.setUser(null);
  }

  return (
    <FadeWrapper>
      <Box
        sx={{
          backgroundColor: theme.palette.background.default,

          flexDirection: "column",
          height: "100vh",
          width: "100%",
        }}
      >
        <AppBar sx={{ bgcolor: theme.palette.appBar }} position="static">
          <Toolbar>
            <IconButton edge="start" color="inherit" aria-label="logo">
              <img src="/logo192.png" alt="Logo" style={{ height: 35 }} />
            </IconButton>
            <Typography
              variant="h5"
              component="div"
              color={"white"}
              sx={{ flexGrow: 1, fontWeight: "bold" }}
            >
              24H自助桌遊館
            </Typography>
            {userContext.user !== null ? (
              <Button
                color="primary"
                sx={{ fontWeight: "bold" }}
                onClick={logout}
              >
                登出{" "}
              </Button>
            ) : (
              <Button
                color="primary"
                onClick={handleLoginOpen}
                sx={{ fontWeight: "bold" }}
              >
                登入/註冊{" "}
              </Button>
            )}
          </Toolbar>
        </AppBar>

        {/* <StyledCardMedia
          image={`${
            process.env.REACT_APP_API_ENDPOINT
          }/media/banner.jpg?${new Date().getTime()}`}
          title="Banner"
        /> */}
<ImageGallery></ImageGallery>
        <Stack
          height={"8%"}
          justifyContent="center"
          direction="row"
          marginY={2}
          marginX={2}
          spacing={2}
        >
          <FullWidthButton
            onClick={() => {
              handleButtonClick("/app/reservation");
            }}
            variant="contained"
            color="primary"
          >
            <Box
              component="img"
              src={reserveIcon}
              sx={{ width: "40px", height: "40px", marginRight: "3px" }}
            />
            預約訂位
          </FullWidthButton>

          <SecondFullWidthButton
            background={theme.palette.primary.main}
            variant="contained"
            color="primary"
            onClick={() => {
              setOpenQRCode(!openQRCode);
            }}
          >
            <Box
              component="img"
              src={qrcodeIcon}
              sx={{ width: "40px", height: "40px", marginRight: "3px" }}
            />
            會員條碼
          </SecondFullWidthButton>
        </Stack>
        <Stack
          height={"12%"}
          direction={"row"}
          justifyContent="space-between"
          marginY={1}
          marginX={4}
        >
          <CustomIconButton
            customIcon={couponIcon}
            text={"優惠券"}
            onClick={() => {
              handleButtonClick("/app/coupon");
            }}
            variant="contained"
            color="primary"
          ></CustomIconButton>
          <CustomIconButton
            customIcon={pointIcon}
            text={"集點卡"}
            onClick={() => {
              handleButtonClick("/app/rewardCard");
            }}
            variant="contained"
            color="primary"
          ></CustomIconButton>
          <CustomIconButton
            customIcon={orderIcon}
            text={"我的訂單"}
            onClick={() => {
              handleButtonClick("/app/myOrder");
            }}
            variant="contained"
            color="primary"
          ></CustomIconButton>
          <CustomIconButton
            customIcon={userIcon}
            text={"個人中心"}
            onClick={() => {
              handleButtonClick("/app/profile");
            }}
            variant="contained"
            color="primary"
          ></CustomIconButton>
        </Stack>
        <TabsView></TabsView>
      </Box>

      <LoginDialog
        openLogin={loginOpen}
        handleLoginClose={() => setLoginOpen(false)}
        setToken={setToken}
      />
      <QRCodeDialog
        open={openQRCode}
        qrString={
          userContext.user !== null ? "user_id:" + userContext.user.Id : ""
        }
        infoString={
          userContext.user !== null ? "請直接於售票機掃描" : "尚未登入"
        }
        onClose={() => {
          setOpenQRCode(!openQRCode);
        }}
      ></QRCodeDialog>
    </FadeWrapper>
  );
};
export default MainPage;
